import React__default from 'react';
import { useMove } from '@react-aria/interactions';

var useDraggable = function useDraggable(ref) {
  var _React$useState = React__default.useState({
    x: 0,
    y: 0
  }),
      position = _React$useState[0],
      setPosition = _React$useState[1];

  var _useMove = useMove({
    onMove: function onMove(event) {
      var _ref$current;

      var rect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect(); // Prevent dragging out of bounds

      // Prevent dragging out of bounds
      if (rect && (rect.left + event.deltaX < 0 || rect.right + event.deltaX > window.innerWidth || rect.top + event.deltaY < 0 || rect.bottom + event.deltaY > window.innerHeight)) {
        return;
      }

      setPosition(function (_ref) {
        var x = _ref.x,
            y = _ref.y;
        x += event.deltaX;
        y += event.deltaY;
        return {
          x: x,
          y: y
        };
      });
    }
  }),
      moveProps = _useMove.moveProps;

  return {
    position: position,
    handleProps: moveProps
  };
};

export { useDraggable };
//# sourceMappingURL=useDraggable.js.map
